import ContactSourceIcon from 'flow/components/custom-components/ContactSourceIcon';
import Icon from 'flow/components/ui-components/Icon';
import useAppContext from 'flow/hooks/useAppContext';
import { extractName } from 'flow/utils';
import { prettyFormatE164Number } from 'flow/utils/call-utils';
import {
    getContactNameOrCompanyName,
    getContactNumber,
} from 'flow/utils/contact-utils';
import {
    ContactType,
    isDynamicSourceContact,
    isGoogleContact,
    isIntegrationContact,
    isMicrosoftContact,
} from 'flow/utils/extension-utils';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import NumberWrapper from '../ui-components/NumberWrapper';

const ContactTypeField = (props) => {
    const { contact, number, loggedInUserCountryCode } = props;
    const { i18next } = useAppContext();

    const getDescription = () => {
        if (contact) {
            if (isGoogleContact(contact)) {
                return i18next.t('ContactCard.SocialIntegrationContact.Title', {
                    socialPlatform: 'Google',
                });
            } else if (isMicrosoftContact(contact)) {
                return i18next.t('ContactCard.SocialIntegrationContact.Title', {
                    socialPlatform: 'Microsoft',
                });
            } else if (isIntegrationContact(contact)) {
                return i18next.t('ContactCard.SocialIntegrationContact.Title', {
                    socialPlatform: contact.get('contactSource'),
                });
            } else if (isDynamicSourceContact(contact)) {
                return i18next.t('ContactCard.SocialIntegrationContact.Title', {
                    socialPlatform: contact.get('sourceDescription'),
                });
            } else {
                switch (contact.get('type')) {
                    case ContactType.shared.key:
                        return i18next.t('ContactCard.SharedContact.Title');
                    case ContactType.personal.key:
                        return i18next.t('ContactCard.PersonalContact.Title');
                    default:
                        return i18next.t('ContactCard.LookupContact.Title');
                }
            }
        }

        return i18next.t('Contact.Unknown');
    };

    const phoneNumber = contact ? getContactNumber(contact) : number;
    const phoneNumberPrettyFormatted = prettyFormatE164Number(
        phoneNumber,
        loggedInUserCountryCode,
    );
    const contactNameOrCompanyName = getContactNameOrCompanyName(contact);
    const title = contact
        ? extractName(contact, i18next.t('Contact.Unknown'))
        : phoneNumberPrettyFormatted;

    const isSharedContact =
        contact.get('type') === ContactType.shared.key ||
        isGoogleContact(contact) ||
        isMicrosoftContact(contact);

    return (
        <div className="flex flex-1 flex-col overflow-hidden break-words">
            <div className="overflow-hidden text-2xl whitespace-nowrap">
                {title}
            </div>
            {contactNameOrCompanyName && (
                <div className="mb-1 items-center text-gray-500">
                    <NumberWrapper>{phoneNumberPrettyFormatted}</NumberWrapper>
                </div>
            )}
            <div className="flex items-center gap-1 text-sm text-gray-500">
                {!isSharedContact &&
                !contact.get('type') === ContactType.global.key ? (
                    <div>
                        {contact ? (
                            <span className="flex size-5 items-center justify-center rounded-sm bg-gray-200 text-gray-600">
                                {contact.get('sourceIcon') ? (
                                    <ContactSourceIcon
                                        src={contact.get('sourceIcon')}
                                    />
                                ) : null}

                                {isSharedContact ? (
                                    <Icon iconKey="shared" size="1rem" />
                                ) : null}

                                {contact.get('type') ===
                                ContactType.global.key ? (
                                    <Icon iconKey="lookUp" size="1rem" />
                                ) : null}
                            </span>
                        ) : null}
                    </div>
                ) : null}

                <div>{getDescription()}</div>
            </div>
        </div>
    );
};

ContactTypeField.propTypes = {
    contact: PropTypes.instanceOf(Map),
    number: PropTypes.string,
    loggedInUserCountryCode: PropTypes.string,
};

export default ContactTypeField;
